/// <amd-module name="Wit/Common/QueryUtils/QueryUtils" />
import { localeDateFormat } from "VSS/Platform/Date";
import { getDateInUserTimeZone } from "Wit/Common/DateUtils";
import { FieldFlags } from "Wit/Common/Generated/Constants";
import * as Resources from "Wit/Common/QueryUtils/Resources";

export const checkFlag = (flags: FieldFlags, flag: FieldFlags): boolean => {
    return (flags & flag) !== FieldFlags.None;
};

/**
 * Converts the specified value to a display string.
 *
 * @param value The value to convert.
 * @param format Date string format if the value is a date in some form (number or Date object)
 */
export function convertValueToDisplayString(value: any, format?: string): string {
    const options: Intl.DateTimeFormatOptions = { year: "numeric", month: "numeric", day: "numeric", hour: "numeric", minute: "numeric" };
    const dateTimeFormat: Intl.DateTimeFormat = new Intl.DateTimeFormat(undefined, options);

    if (value !== null && value !== undefined) {
        if (typeof value === "string") {
            return value;
        } else if (value instanceof Date) {
            return localeDateFormat(getDateInUserTimeZone(value), format, dateTimeFormat);
        } else if (typeof value === "number") {
            if (format) {
                return localeDateFormat(getDateInUserTimeZone(new Date(value)), format, dateTimeFormat);
            } else {
                return value.toLocaleString(format, options);
            }
        } else if (typeof value === "boolean") {
            return value ? Resources.True : Resources.False;
        } else if (typeof value === "object" && value.distinctDisplayName) {
            return value.distinctDisplayName;
        } else {
            return value.toString();
        }
    }

    return "";
}
